/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskMetricSummary } from './RiskMetricSummary';
import {
  RiskMetricSummaryFromJSON,
  RiskMetricSummaryFromJSONTyped,
  RiskMetricSummaryToJSON,
} from './RiskMetricSummary';
import type { AuxiliaryMetricResultStub } from './AuxiliaryMetricResultStub';
import {
  AuxiliaryMetricResultStubFromJSON,
  AuxiliaryMetricResultStubFromJSONTyped,
  AuxiliaryMetricResultStubToJSON,
} from './AuxiliaryMetricResultStub';

/**
 *
 * @export
 * @interface RiskMetricResultSummary
 */
export interface RiskMetricResultSummary {
  /**
   *
   * @type {number}
   * @memberof RiskMetricResultSummary
   */
  readonly id: number;
  /**
   *
   * @type {RiskMetricSummary}
   * @memberof RiskMetricResultSummary
   */
  readonly metric: RiskMetricSummary;
  /**
   *
   * @type {Array<AuxiliaryMetricResultStub>}
   * @memberof RiskMetricResultSummary
   */
  readonly auxiliaryMetrics: Array<AuxiliaryMetricResultStub>;
  /**
   *
   * @type {number}
   * @memberof RiskMetricResultSummary
   */
  value: number;
  /**
   *
   * @type {number}
   * @memberof RiskMetricResultSummary
   */
  confidenceLow?: number | null;
  /**
   *
   * @type {number}
   * @memberof RiskMetricResultSummary
   */
  confidenceHigh?: number | null;
  /**
   *
   * @type {string}
   * @memberof RiskMetricResultSummary
   */
  comment?: string;
  /**
   *
   * @type {boolean}
   * @memberof RiskMetricResultSummary
   */
  isApplicable?: boolean;
}

/**
 * Check if a given object implements the RiskMetricResultSummary interface.
 */
export function instanceOfRiskMetricResultSummary(value: object): value is RiskMetricResultSummary {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('metric' in value) || value['metric'] === undefined) return false;
  if (!('auxiliaryMetrics' in value) || value['auxiliaryMetrics'] === undefined) return false;
  if (!('value' in value) || value['value'] === undefined) return false;
  return true;
}

export function RiskMetricResultSummaryFromJSON(json: any): RiskMetricResultSummary {
  return RiskMetricResultSummaryFromJSONTyped(json, false);
}

export function RiskMetricResultSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskMetricResultSummary {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    metric: RiskMetricSummaryFromJSON(json['metric']),
    auxiliaryMetrics: (json['auxiliary_metrics'] as Array<any>).map(AuxiliaryMetricResultStubFromJSON),
    value: json['value'],
    confidenceLow: json['confidence_low'] == null ? undefined : json['confidence_low'],
    confidenceHigh: json['confidence_high'] == null ? undefined : json['confidence_high'],
    comment: json['comment'] == null ? undefined : json['comment'],
    isApplicable: json['is_applicable'] == null ? undefined : json['is_applicable'],
  };
}

export function RiskMetricResultSummaryToJSON(
  value?: Omit<RiskMetricResultSummary, 'id' | 'metric' | 'auxiliaryMetrics'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    value: value['value'],
    confidence_low: value['confidenceLow'],
    confidence_high: value['confidenceHigh'],
    comment: value['comment'],
    is_applicable: value['isApplicable'],
  };
}
